import React, { Component, useEffect } from 'react';
//import { withNavigation } from 'react-navigation'; // 画面遷移時に再描画するために必要 1/4

import { Alert } from 'react-native';

import { cf } from './cf';
import { ce } from './ce';
import { ic } from './ic';
import { bf } from './bf';

/*
class cMsgSet extends React.Component {

    state = cf.myRN_crt_stss({
        s_ct21c310: '',
        sdd_itemss: {
        },
    })

    componentDidMount() {
      cf.myRN_stt(this, ()=>{ // 画面遷移時に再描画するために必要 2/4            
        if (global.c?.state.sgc_pageMode == 'show') {
          global.c?.load();
        };
      });
    }

    componentWillUnmount() {
      cf.myRN_end(); // 画面遷移時に再描画するために必要 3/4
    }

    load = () => {
      cf.myRN_load([
        new Promise( _o_end1 => { // グループ名の反映
          let _cnd = bf.q('[_KEY]={}'.f(global.c?.state.sgc_pageKey));
          cf.myCB_call_slc('nlm', 'ct21', 2, '', '')
          .then( _d_ct21s => {
            if (bf.f(_d_ct21s)) {
              global.c?.setState({
                s_ct21c310: _d_ct21s.ct21c310,
              }, ()=>{
                _o_end1();
              });
            }
            else {
              _o_end1();
            }
          });
        }),
        new Promise( _o_end1 => { // メンバの反映
          let _cnd = bf.q('[ct22b11k]="{}" AND IFNULL([ct22cz10],"10")="10"'.f(global.c?.state.sgc_pageKey));
          cf.myCB_call_slc('nlm', 'ct22', 3, _cnd, '')
          .then( _ld_ct22ss => {
            global.c?.setState({
              sdd_itemss: {}
            }, () => {
              if (bf.f(_ld_ct22ss)) {
                let _dd_cashss = {};
                for (let [_idx, _d_ct22s] of bf.e(_ld_ct22ss)){
                  let _cnd2 = bf.q('[_KEY]={}'.f(_d_ct22s.ct22b21k));
                  cf.myCB_call_rfr(_d_ct22s, 'cm10', _cnd2) // 重複データは想定されないため、キャッシュを使用しない
                  .then( _d_ct22s2 => {
                    global.c?.setState({
                      sdd_itemss: bf.p(global.c?.state.sdd_itemss, _next => {
                        _next['{}'.f(_d_ct22s2._KEY)] = {
                          key: _d_ct22s2._KEY,
                          pfx: _d_ct22s2.cm10c310,
                        };
                      }),
                    }, ()=>{
                    });
                  });
                };
              }
              _o_end1();
            });
          });
        }),
      ]);
    };
    
    ins = () => {
      cf.myRN_ins(new Promise( _o_end1 => { // グループの新規登録
        new Promise( _o_end2 => { // グループ名の設定
          if (global.c?.state.s_ct21c310 == '') {
            let _s = '';
            for (let [_key, _d_items] of bf.e(global.c?.state.sdd_itemss)) {
              _s += (_s != '') ? ' {}'.f(_d_items.pfx) : '{}'.f(_d_items.pfx)
            };
            global.c?.setState({
              s_ct21c310: _s
            }, ()=>{
              _o_end2();
            });
          }
          else {
            _o_end2();
          };
        })
        .then(()=>{ // グループの登録
          let _d_vals = {
            ct21l11e: 'cm20',
            ct21l11k: global.c?.state.sgcd_pagePntKeys.cm20_key,
            ct21c110: '',
          };
          cf.myCB_call_iud('ins', 'ct21', _d_vals, '', '')
          .then(_d_ct21s => {
            _o_end1(_d_ct21s);
          });
        })
      }));
    };

    upd = () => {
      cf.myRN_upd([ // グループの上書き更新
        new Promise( _o_end1 => { // グループ名の更新
          let _d_vals = {
            ct21c310: global.c?.state.s_ct21c310,
          };
          let _cnd = bf.q('[_KEY]={}'.f(global.c?.state.sgc_pageKey));
          cf.myCB_call_iud('upd', 'ct21', _d_vals, _cnd, '')
          .then( () => {
            _o_end1();
          });
        }),
        new Promise( _o_end1 => { // グループメンバの追加・更新
          //
          if (!bf.f(global.c?.state.sdd_itemss)) {
            _o_end1();
          }
          //
          for (let [_key, _d_items] of bf.e(global.c?.state.sdd_itemss)) {
            let _d_vals = {
              ct22b11k: global.c?.state.sgc_pageKey,
              ct22b21k: _d_items.key,
              ct22cz10: (_d_items.b_dlt == true) ? '0' : '10',
              ct22i110: ic.gd_stgs.cmn.minDtm,
            };
            let _cnd = bf.q('[ct22b11k]="{}" AND [ct22b21k]="{}"'.f(
              global.c?.state.sgc_pageKey,
              _d_items.key,
            ));
            cf.myCB_call_iud('ups', 'ct22', _d_vals, _cnd, '')
            .then( () => {
              _o_end1();
            });
          };
        })
      ])
    };
    //
    render() {
      return (
        <ce.RootDtl
          key={-1}
          crrPage='cMsgSet'
          d_hdrs={global.c?.state.sgcd_hdrs}
          b_logo={false}
          onPckSchMdlEnt={(_schWord)=>{
            let _cnd = bf.q('[cm10c310] LIKE "%{}%"'.f(_schWord));
            cf.myCB_call_slc('nlm', 'cm10', 3, _cnd, '')
            .then( _ld_cm10ss => {
              global.c?.setState({
                sgcd_mdls: bf.p(global.c?.state.sgcd_mdls, _next => {
                  let _dd_itemss = {};
                  for (let [_idx, _d_cm10s] of bf.e(_ld_cm10ss)) {
                    _dd_itemss[_d_cm10s._KEY] = {
                      key: _d_cm10s._KEY,
                      pfx: _d_cm10s.cm10c310,
                    };
                  };
                  _next.pckSch.dd_listItemss = _dd_itemss;
                }),
              }, ()=>{
              });
            });
          }}
          b_rhtVsb={true}
          ld_bdyDefss={[
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
              state:'s_ct21c310',
              pfx:'グループ名',
              phd:'省略時はメンバ名を設定',
              b_mln:false,
            },
            {
              type: 'PckSchs',
              b_vsb: true,
              b_edt:(bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
              state: 'sdd_itemss',
              pfx: 'メンバ',
            },
          ]}
        />
      );
    }
}

export default withNavigation(cMsgSet); // 戻るで再描画するために必要 4/4
*/

import cView from './cView';

export default class cMsgSet extends cView {

  $id_stgs = { //  子で上書き
  };

  $cd_stss = { // 親を上書き
    sld_itemss: [],
  };

  $clp_loads = () => [ // 親を上書き
    new Promise( _o_end1 => { // グループ名の反映
      if (global.c?.state.sgc_pageMode == 'show') {
        let _cnd = bf.q('[_KEY]={}'.f(
//          global.c?.state.sgc_pageKey
          global.c?.state.sgcd_pagePntKeys.ct21_key
        ));
        cf.myCB_call_slc({
          ctr: 'nlm', 
          elm: 'ct21', 
          n_dms: 2,
          cnd: _cnd,
        })
        .then( _d_ct21s => {
          if (bf.f(_d_ct21s)) {
            global.c?.setState({
              s_ct21c310: _d_ct21s.ct21c310 ?? '',
              s_ct21cz10: _d_ct21s.ct21cz10 ?? '10', // 20211003 削除対応
            }, ()=>{
              _o_end1();
            });
          }
          else {
            _o_end1();
          }
        });
      }
      else {
        _o_end1();
      };
    }),

    new Promise( _o_end1 => { // メンバの反映
      if (global.c?.state.sgc_pageMode == 'show') {
        let _cnd = bf.q('[ct22b11k]="{}" AND IFNULL([ct22cz10],"10")<>"0"'.f(
//          global.c?.state.sgc_pageKey
          global.c?.state.sgcd_pagePntKeys.ct21_key
        ));
        cf.myCB_call_slc({
          ctr: 'nlm', 
          elm: 'ct22', 
          n_dms: 3, 
          cnd: _cnd,
          do_rfrs: {
            'cm10': _d_ct22s => bf.q('[_KEY]={}'.f(
              _d_ct22s.ct22b21k
            )),
          }, 
        })
        .then( _ld_ct22ss => {
//  bf.l('259:{}, {}'.f(_cnd, _ld_ct22ss));
          global.c?.setState({
            sld_itemss: _ld_ct22ss.map( _d_ct22s => {
              return {
                key: _d_ct22s.ct22b21k,
                pfx: _d_ct22s.cm10c310,
                d_vals: _d_ct22s,
              };
            }),
          }, ()=>{
bf.l('276:{}'.f(global.c?.state.sld_itemss));
            _o_end1();
          });
        });
      }
      else {
        _o_end1();
      };
    }),

  ];

/*
$clp_bfrIuds = () => [new Promise( _o_end1 => { // 20211003 削除対応
  if (global.c?.state.s_ct21cz10 == '0') {
    Alert.alert(
      '確認', 
      '削除区分を「表示しない」とした場合、メッセージグループ削除されますが宜しいですか？', 
      [
        {
          text: 'はい',
          onPress: () => _o_end1(true),
        },
        {
          text: 'いいえ',
          onPress: () => _o_end1(false),
        },
      ]
    );
  }
  else {
    _o_end1(true);
  }
})];
*/

  $cp_ins = () => new Promise( _o_end1 => {
    new Promise( _o_end2 => { // グループ名の設定
      if (!bf.f(global.c?.state.s_ct21c310)) {
        let _s = '';
        _s = global.c?.state.sld_itemss.reduce( ( _prev, _d_items) => {
          return ((_prev != '') ? ' ' : '') + _d_items.pfx;
        }, '');
        global.c?.setState({
          s_ct21c310: _s
        }, ()=>{
          _o_end2();
        });
      }
      else {
        _o_end2();
      };
    })
    .then(()=>{ // グループの登録
      let _d_vals = {
        ct21l11e: 'cm20',
        ct21l11k: global.c?.state.sgcd_pagePntKeys.cm20_key,
        ct21c110: '',
      };
      cf.myCB_call_iud({
        ctr: 'ins', 
        elm: 'ct21', 
        d_vals: _d_vals
      })
      .then(_d_ct21s => {
        global.c?.setState({
          sgcd_pagePntKeys: bf.p(global.c?.state.sgcd_pagePntKeys, _next => {
            _next.ct21_key = _d_ct21s._KEY;
          }),
        }, () => {
          _o_end1(_d_ct21s);
        });
      });
    })
  });

  $clp_upds = () => [ // 親を上書き
    new Promise( _o_end1 => { // グループ名の更新
      let _d_vals = {
        ct21c310: global.c?.state.s_ct21c310,
        ct21cz10: global.c?.state.s_ct21cz10 ?? '10', // 20211003 削除対応
      };
      let _cnd = bf.q('[_KEY]={}'.f(
//        global.c?.state.sgc_pageKey
        global.c?.state.sgcd_pagePntKeys.ct21_key
      ));
      cf.myCB_call_iud({
        ctr: 'upd', 
        elm: 'ct21', 
        d_vals: _d_vals, 
        cnd: _cnd
      })
      .then( () => {
        _o_end1();
      });
    }),
    new Promise( async _o_end1 => { // グループメンバの追加・更新
      //
      if (!bf.f(global.c?.state.sld_itemss)) {
        _o_end1();
      }
      //
      for await (let [_idx, _d_items] of bf.e(global.c?.state.sld_itemss)) {
        let _d_vals = {
//          ct22b11k: global.c?.state.sgc_pageKey,
          ct22b11k: global.c?.state.sgcd_pagePntKeys.ct21_key,
          ct22b21k: _d_items.key,
          ct22cz10: (_d_items.b_dlt == true) ? '0' : '10',
          ct22i110: bf.minDtm,
        };
        let _cnd = bf.q('[ct22b11k]="{}" AND [ct22b21k]="{}"'.f(
//          global.c?.state.sgc_pageKey,
          global.c?.state.sgcd_pagePntKeys.ct21_key,
          _d_items.key,
        ));
//bf.l('391: {}, {}'.f(_cnd, _d_vals))
        await cf.myCB_call_iud({
          ctr: 'ups', 
          elm: 'ct22', 
          d_vals: _d_vals, 
          cnd: _cnd
        })
        .then( () => {
//bf.l('398: here')
        });
      };
//bf.l('401: here')
      _o_end1();
    }),
  ];

  render() {
    return ( //  子で上書き
      <ce.RootDtl
        b_logo={false}
        b_sch={true}
        onSchEnt={()=>{
          global.c?.load();
        }}
        b_rhtVsb={true}
        rhtIconName={null}
        rhtPfx={null}
        onRhtPrs={null}
        n_bdyW={ic.gn_w}
        d_hdrs={{
          pfx: iv._get_hdrPfx('メッセージグループ'),
          d_leftBtns: iv._get_leftBtns(global.c?.state.sgc_pageRole, global.c?.state.sgc_pageName, global.c?.state.sgc_pageMode),
          d_subMenus: {
            b_vsb: false,
          },
        }}
        d_bdys={{
          ld_defss: [
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
              state:'s_ct21c310',
              pfx:'グループ名',
              phd:'省略時はメンバ名を設定',
              b_mln:false,
            },
            {
              type: 'PckSchs',
              b_vsb: true,
              b_edt:(bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
              state: 'sld_itemss',
              pfx: 'メンバ',
            },
          ],
        }}
        onPckSchMdlEnt={(_schWord)=>{
//          let _cnd = bf.q('[cm10c310] LIKE "%{}%"'.f(_schWord));
          let _cnd = bf.q('[cm10b21k]="{}" AND [cm10c310] LIKE "%{}%"'.f(
            global.c?.state.sgcd_pagePntKeys.cm20_key,
            _schWord,
          ));
          cf.myCB_call_slc({
            ctr: 'nlm', 
            elm: 'cm10', 
            n_dms: 3, 
            cnd: _cnd,
           })
          .then( _ld_cm10ss => {
//bf.l('487:{}, {}'.f(_cnd, _ld_cm10ss))
            global.c?.setState({
              sgcd_mdls: bf.p(global.c?.state.sgcd_mdls, _next => {
                let _ld_iss = _ld_cm10ss.map( _d_cm10s => {
                  return {
                    key: _d_cm10s._KEY,
                    pfx: _d_cm10s.cm10c310,
                  };
                });
                _next.pckSch.ld_itemss = _ld_iss;
              }),
            }, ()=>{
            });
          });
        }}
      />
    );
  }

}
